<template>

    <div class="">
        <div class="bg-back"></div>
        <div style="
    position: absolute;
    top: 0;
    left:calc(50% - 244px);
		" class="cd-user-modal is-visible">
            <div class="cd-user-modal-container">
                <p class="cd-switcher">
                    数字化交付平台
                </p>
                <div id="cd-login" class="is-visible is-selected" v-loading.fullscreen.lock="loading">
                    <form class="cd-form ">
                        <p class="fieldset">
                            <el-input class="full-width has-padding has-border" prefix-icon="el-icon-user"
                                      v-model="username"
                                      maxlength="25" clearable placeholder="请输入账户名"
                            ></el-input>
                        </p>
                        <p class="fieldset">
                            <label class="image-replace cd-password">密码</label>
                            <el-input v-model="password" prefix-icon="el-icon-lock"
                                      class="full-width has-padding has-border"
                                      clearable maxlength="25" show-password placeholder="请输入密码"></el-input>
                        </p>
                        <div class="flex2 mt-5">
                            <div>
                                <el-checkbox type="checkbox" name="remember-password" ref="remember"
                                             v-model="remember"></el-checkbox>
                                <label>记住密码</label>
                            </div>
                          <div>
                            <el-checkbox type="checkbox"
                                         v-model="signle"></el-checkbox>
                            <label>单例登录</label>
                          </div>

                            <p>
                                <span class="text-info2 cursor" @click="$router.push('/forget')">忘记密码</span>
                            </p>
                        </div>
                        <p class="mt-2">
                            <input class="full-width" type="button" @click="login_in()" value="登录">
                        </p>

                    </form>
                </div>
              <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
                         :visible.sync="dialogVisible" :modal-append-to-body="false"
                         width="70%" class="mr-2" style="margin:0 auto">
                <div class="flex3 mb-3" style="padding-left: 12%">
                  <span class="lh40">请选择功能组：</span>
                  <el-select v-model="funcName" placeholder="请选择" value-key="id"
                             @change="changefunc" size="mini" style="">
                    <el-option
                        v-for="(item,index) in funcList"
                        :key="index"
                        :label="item.name"
                        :value="item">
                    </el-option>
                  </el-select>
                </div>
              </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import JSEncrypt from 'jsencrypt'

export default {
    name: "login",
    data() {
        let check_password = (rule, value, callback) => {
            if (!this.check_password_same()) {
                callback(new Error("两次密码不一致！！"));
            } else {
                callback();
            }
        };
        let check_account = (rule, value, callback) => {
            let state = this.check_account_exists()
            if (state === 1001) {
                callback(new Error("不能含有特殊字符！！"));
            } else if (state === false) {
                callback(new Error("账号已存在！！"));
            } else {
                callback();
            }
        };
        return {
            time_id: '',
            code_disable: 0,
            loading: false,
            username: '',
            password: '',
            height: window.screen.height + 'px',
            dialogVisible: false,
            joindialogVisible: false,
            proName: '',
            projectList: this.$store.state.project_list,
            bim_flag: true,
            remember: false,
            join_code: '',
            register_visible: false,
            form: {
                account: '',
                password: '',
                password2: '',
                phone: '',
                code: '',
                project_code: null,
            },
            rules: {
                account: [
                    {required: true, message: '请输入账号', trigger: 'blur'},
                    {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'},
                    {validator: check_account, trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {pattern: /^1[3456789]\d{9}$/, message: "手机号格式不对", trigger: "blur"},
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'},
                    {validator: check_password, trigger: 'blur'}
                ],
                password2: [
                    {required: true, message: '请确认密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'},
                    {validator: check_password, trigger: 'blur'}
                ],
                code: [
                    {required: true, message: '请输入验证码', trigger: 'blur'},
                    {pattern: /^[0-9]*$/, min: 6, max: 6, message: '请输入6位数字', trigger: 'blur'},
                ],
                project_code: [
                    {min: 32, max: 32, message: '长度在32位', trigger: 'blur'},
                ]
            },
          funcList:[],
          funcName:'',
          signle:true,
          user_id:'',
        }
    },
    mounted() {
        this.checkCookie();
        // window.addEventListener('keydown', this.keyDown);

    },
    methods: {
      //选择功能组后刷新token
      refreshToken(id){
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/Login/RefreshToken',
          data: {
            "version": "1.1",
            "data": {
              "single": this.signle,
              "user_id": this.user_id,
              "project_id": '',
              "function_group_id": id,
            }
          },
        }).then((response) => {
          console.log(response.data)
          this.$axios.defaults.headers.common['Authorization'] = response.data.content.token
          this.$store.commit('get_auth_key', response.data.content.token)
          this.$router.push({path: '/IBMS/platform/createNewProject'});
        })
      },
      changefunc(item){
        console.log(item)
        this.$store.commit('checkAuthList', item.auth)
        this.refreshToken(item.id)
      },
        //关闭注册弹窗
        close_register() {
            this.form = {
                account: '',
                password: '',
                password2: '',
                phone: '',
                code: '',
                project_code: null,
            }
            clearInterval(this.time_id)
            this.code_disable = 0
            this.register_visible = false
        },
        //验证密码是否一致
        check_password_same() {
            return this.form.password === this.form.password2;
        },
        //验证是否包含特殊字符
        checkSpecialKey(str) {
            let specialKey = "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for (let i = 0; i < str.length; i++) {
                if (specialKey.indexOf(str.substr(i, 1)) !== -1) {
                    return false;
                }
            }
            return true;
        },
        //回车键登录
        keyDown(e) {
            //如果是回车则执行登录方法
            if (e.keyCode === 13) {
                this.login_in();
            }
        },

        checkCookie() {
            if (this.Cookies.get("uname") != null && this.Cookies.get("upwd") != null) {
                this.remember = true
                this.username = this.Cookies.get("uname");
                this.password = this.Cookies.get("upwd");
            }
        },
        login_in() {
          let encryptor = new JSEncrypt()
          encryptor.setPublicKey(this.$store.state.public_key)
          let rsaPassWord = encryptor.encrypt(this.password)
            this.$axios({
                method: 'post',
              url: this.IBMS_API + 'IBMS/Login/Login',
                data: {
                    "version": "1.1",
                    "data": {
                        "username": this.username,
                        "password": rsaPassWord,
                    }
                },
            }).then((response) => {
                if (response.data.result === 200) {
                  this.user_id=response.data.content.user_id
                  this.$store.commit('get_user_id', response.data.content.user_id)
                  if(response.data.content.plat_list.length===0){
                    this.$message({
                      message: '该账号没有可用的平台',
                      type: 'error'
                    });
                    } else {
                    if(response.data.content.plat_list.length===1){
                      this.funcList=response.data.content.plat_list
                      this.$store.commit('funcList', response.data.content.plat_list)
                      this.$store.commit('checkAuthList', response.data.content.plat_list[0].auth)
                      this.refreshToken(this.funcList[0].id)
                    } else if(response.data.content.plat_list.length>1){
                      this.dialogVisible=true
                      this.funcList=response.data.content.plat_list
                      this.$store.commit('funcList', response.data.content.plat_list)
                    }
                  }
                  //记住密码
                  if (this.remember) {
                    this.Cookies.set("uname", this.username);
                    this.Cookies.set("upwd", this.password);
                  } else {
                    this.Cookies.remove("uname");
                    this.Cookies.remove("upwd");
                  }
                }
                else {
                    this.$message({
                        showClose: true,
                        duration: 3000,
                        message: '用户名或密码错误，请重新登录',
                        type: 'error'
                    })
                }
            })
        },
    },
}
</script>

<style scoped>
/*修改提示文字的颜色*/
/deep/ input::-webkit-input-placeholder {
    color: #ffffffba;
}

/deep/ .el-input {
    margin-bottom: 5px;
}

/deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #1a1a1d5e;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #1a1a1d00;
    box-sizing: border-box;
    color: #ffffffba;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 30px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
}

.content_input .el-input__inner {
    -webkit-appearance: none;
    background-color: #272d3529;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #ffffff73;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
}

.form-checkbox-radio label {
    padding: 4px 15px 0 0;
    height: 16px;
    line-height: 10px;
    margin-left: 5px;
    color: #d9d5d5;
    display: block;
    float: left;
}

.form-checkbox-radio input {
    display: block;
    float: left;
}

.content_button {
    text-align: center;
    margin-top: 10px;
}

.title {
    text-align: center;
    font-size: 21px;
    margin-bottom: 30px;
    font-weight: bold;
    color: #dbdee1;
    margin-top: 10px;
}

/deep/ .el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    text-align: center;
}
</style>
